import Vue from "vue"
import Vuex, { Store } from "vuex"
import VuexPersist from "vuex-persist"
import UserInfo from "./user_info"
import StoreOps from "@/util/store_ops"
import { SocketMessage } from "mangutil"

interface MangerooState {
  incomingMessage: SocketMessage
  user: UserInfo
}

Vue.use(Vuex)

var vuexStore: Store<MangerooState> = null

var cookiesEnabled = navigator.cookieEnabled

if (cookiesEnabled) {
  var vuexLocalStorage = new VuexPersist({
    key: "vuex",
    storage: window.localStorage,
  })

  vuexStore = new Vuex.Store<MangerooState>({
    plugins: [vuexLocalStorage.plugin],
    state: (): MangerooState => ({
      incomingMessage: null,
      user: new UserInfo(),
    }),
    mutations: {
      [StoreOps.LOGOUT](state: MangerooState) {
        state.user.loggedIn = false
        state.user.vorname = null
        state.user.nachname = null
        state.user.username = null
        state.user.role = null
        state.user.key = null
        state.user.betriebId = null
        state.user.admin = false
        state.user.expires = null
      },
      [StoreOps.POST_INCOMING_MESSAGE](
        state: MangerooState,
        payload: SocketMessage
      ) {
        state.incomingMessage = payload
      },
      [StoreOps.UPDATE_IDENTIFIER](state: MangerooState, payload: string) {
        state.user.identifier = payload
      },
    },
  })
}

export default vuexStore
